import React from 'react';
import cx from 'classnames';

import './chevronButton.less';

type ChevronButtonProps = {
  onClick?: React.MouseEventHandler;
  direction: 'left' | 'right' | 'up' | 'down';
  btnStyle?: 'primary' | 'secondary' | 'tertiary';
  className?: string;
  ariaLabel?: string;
  inverse?: boolean;
  anchor?: string;
};

/**
 * Directional button to move to a different section on the same page
 * Note: The disabled line is to address a screen reader issue: https://hub.accessible360.com/issues/60593/edit
 */
const ChevronButton: React.FC<ChevronButtonProps> = (props) => {
  const { direction, btnStyle, className, onClick, ariaLabel, inverse, anchor } = props;
  const classes = cx(
    'zola-ui',
    'chevron-button',
    'btn',
    `chevron-button--${btnStyle}`,
    inverse ? 'chevron-button--inverse' : '',
    className
  );

  if (anchor) {
    return (
      <a
        href={`#${anchor}`}
        className={classes}
        onClick={onClick}
        aria-label={ariaLabel || `navigate ${direction}`}
      >
        {' '}
        <span
          className={`chevron-button_icon chevron-button_icon--${direction} zola-ui-icon-chevron-${direction}`}
          aria-hidden="true"
        />
      </a>
    );
  }

  return (
    <button
      aria-label={ariaLabel || `navigate ${direction}`}
      type="button"
      className={classes}
      onClick={onClick}
    >
      <span
        className={`chevron-button_icon chevron-button_icon--${direction} zola-ui-icon-chevron-${direction}`}
        aria-hidden="true"
      />
    </button>
  );
};

ChevronButton.defaultProps = {
  btnStyle: 'primary',
  className: '',
  inverse: false,
};

export default ChevronButton;
